import { Slide, SlideProps, Snackbar } from "@mui/material";
// @ts-expect-error -- @types/react-dom not declared in shared-ui; tracked separately
import { createRoot } from "react-dom/client";
import { ReactNode, useEffect } from "react";
import SnackbarMessage from "../theme/extensions/SnackbarMessage";

type ToastVariant = "success" | "error" | "info" | "warning" | "neutral";

function SlideTransition(props: Readonly<SlideProps>) {
  return <Slide {...props} direction="up" />;
}

// Global Toast utility. Creates a detached DOM node and renders a Snackbar into it.
// Automatically cleans itself up after timeout.
export function Toast(
  message: ReactNode,
  errorOrVariant?: boolean | ToastVariant,
  timeout: number = 4000,
): void {
  const variant: ToastVariant =
    typeof errorOrVariant === "boolean"
      ? errorOrVariant ? "error" : "success"
      : errorOrVariant ?? "success";

  const host = document.createElement("div");
  document.body.appendChild(host);
  const root = createRoot(host);

  const cleanup = () => {
    if (typeof window === "undefined") return;
    root.unmount();
    host.remove();
  };

  const Toaster = () => {
    useEffect(() => {
      const timer = setTimeout(cleanup, timeout);
      return () => clearTimeout(timer);
    }, [host]);

    return (
      <Snackbar
        open
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slots={{
          transition: SlideTransition
        }}
      >
        <div>
          <SnackbarMessage
            variant={variant}
            message={message}
          />
        </div>
      </Snackbar>
    );
  };

  root.render(<Toaster />);
}
